<mat-dialog-content class="cardActivation" #container>
  <div class="otpDialog">
    <div class="messageContainer"
         [ngClass]="{'errorMessage': formError, 'successMessage': formSuccess}">
      <span *ngIf="formError || formSuccess">{{ formMessage }}</span>
    </div>
    <h4>{{ labels.OTP_HEADER }}</h4>
    <div class="communicationInfo">
      <mat-icon matSuffix *ngIf="preferredDevice === 'Email'">email</mat-icon>
      <mat-icon matSuffix *ngIf="preferredDevice === 'Mobile'">mobile_friendly</mat-icon>
      <strong>{{ preferredDevice === 'Email' ? data.email : data.mobile }}</strong>
      <div class="userHints" *ngIf="preferredDevice === 'Email'">
        {{ labels.OTP_EMAIL_PROMPT }}
      </div>
      <div class="userHints" *ngIf="preferredDevice === 'Mobile'">
        {{ labels.OTP_MOBILE_PROMPT }}
      </div>
    </div>
    <div class="verificationOptions">
      <div *ngIf="(preferredDevice === 'Email' && data.mobile) || (preferredDevice === 'Mobile' && data.email)" class="optionChange">
        <button
          mat-raised-button
          class="linkButton swapDevice"
          (click)="updatePreferredDevice(true, 'deviceChange'); sendOTP()">
          <mat-spinner *ngIf="retryType === 'deviceChange'" diameter="20" mode="indeterminate"></mat-spinner>
          <span *ngIf="retryType !== 'deviceChange'">{{ labels.OTP_OTHER_VERIFICATION }}
            <strong>{{ preferredDevice === 'Email' ? data.mobile : data.email }}</strong></span>
        </button>
      </div>
      <div class="resendCode">
        <span>{{ labels.OTP_DINT_GET_CODE }}</span>
        <button mat-raised-button class="linkButton resend" (click)="updatePreferredDevice(false, 'resend'); sendOTP()">
          <mat-spinner *ngIf="retryType === 'resend'" diameter="20" mode="indeterminate"></mat-spinner>
          <span *ngIf="retryType !== 'resend'" >{{ labels.OTP_SEND_AGAIN }}</span>
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>
    <form [formGroup]="otpForm" (ngSubmit)="verifyOtp(container)">
      <mat-form-field>
        <mat-label>{{ labels.OTP_CODE }}</mat-label>
        <input matInput formControlName="otpNumber" maxlength="6" />
        <mat-error>
          {{ labels.OTP_INVALID_INPUT }}
        </mat-error>
      </mat-form-field>
      <button mat-raised-button color="accent" class="otpButton"
              [disabled]="loading || !otpForm.valid" type="submit">
        <mat-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-spinner>
        <span *ngIf="!loading" >{{ labels.OTP_VERIFY }}</span>
      </button>
    </form>
    <div class="cancelButtonWrapper">
      <button mat-raised-button class="linkButton cancel" (click)="closeDialog()">
        {{ labels.OTP_CANCEL }}
      </button>
    </div>
    <div class="userHints">
      {{ labels.OTP_HELP }}
    </div>
  </div>
</mat-dialog-content>
